import React, { useState } from 'react';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import Input from 's2s-input';
import Button from 's2s-button';
import PropTypes from "prop-types";
import { validatePassword } from '../js/utilities.js';
import { getIntlText } from '../js/utilities';
import { injectIntl } from 'react-intl';

// Styles the Container
const ChangePasswordContainer = styled.div`
  background: ${colorGrid.gray0};
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(33, 37, 41, 0.4);
  padding : 48px;
`;

const BottomInput = styled(Input)`
  margin-top: 16px;
`;

const FooterContainer = styled.div`
  align-items : center;
  display : flex;
  justify-content : space-between;
  margin-top : 24px;
`;

const ChangePasswordButton = styled(Button)`
  text-transform : uppercase;
`;

const CancelButton = styled(Button)`
  height : 40px;
  border : 1px solid ${colorGrid.gray3};
  text-transform : uppercase;

  &:hover {
    background-color : ${colorGrid.gray2};
  }
`;

const ChangePassword = (props) => {

  const [passwordMeetsRequirementsError, setPasswordMeetsRequirementsError] = useState(false);
  const [passwordsMatchError, setPasswordsMatchError] = useState(false);
  const [passwordValue, setPasswordValue] = useState('');
  const [confirmPwdValue, setConfirmPwdValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const inputsInvalid = () => isLoading || getPasswordFormatErrors(true) || getPasswordMatchErrors(true);
  const handleNewPasswordChange = (inputValue) => {
    setPasswordValue(inputValue);
  };
  const handleConfirmPasswordChange = (inputValue) => {
    setConfirmPwdValue(inputValue);
  };
  const getPasswordFormatErrors = (returnValue) => {
    const hasError = !validatePassword(passwordValue);
    if (returnValue) {
      return hasError;
    } else {
      setPasswordMeetsRequirementsError(hasError);
    }
  };
  const getPasswordMatchErrors = (returnValue) => {
    const hasError = !passwordValue || (passwordValue !== confirmPwdValue);
    if (returnValue) {
      return hasError;
    } else {
      setPasswordsMatchError(hasError);
    }
  };
  const handleResetClick = () => {
    setIsLoading(true);
    setPasswordsMatchError(passwordValue !== confirmPwdValue);

    if (!passwordsMatchError && !passwordMeetsRequirementsError) {
      props.cbResetClick(passwordValue);
    } else {
      setIsLoading(false);
    }
  };

  return (
    <ChangePasswordContainer className="ChangePasswordContainer">
      <Input
        autoFocus
        value={passwordValue}
        inputLabel={getIntlText(props.intl, 'CHANGE-PASSWORD-PASSWORD-LABEL', "Enter a new password for your account.")}
        placeholder={getIntlText(props.intl, 'CHANGE-PASSWORD-PASSWORD-PLACEHOLDER', "Enter your password...")}
        errorText={getIntlText(props.intl, 'RESET-PASSWORD-NEW-PASSWORD-ERROR-TEXT', "Password does not meet requirements")}
        hasError={passwordMeetsRequirementsError}
        inputType="password"
        svgType="LockIconSVG"
        cbOnBlur={() => getPasswordFormatErrors()}
        cbOnEnter={handleResetClick}
        cbOnChange={handleNewPasswordChange}
      />
      <BottomInput
        autoFocus={false}
        value={confirmPwdValue}
        placeholder={getIntlText(props.intl, 'CHANGE-PASSWORD-CONFIRM-PASSWORD-PLACEHOLDER', "Confirm your password...")}
        errorText={getIntlText(props.intl, 'RESET-PASSWORD-CONFIRM-PASSWORD-ERROR-TEXT', "Passwords do not match")}
        hasError={passwordsMatchError}
        inputType="password"
        svgType="LockIconSVG"
        cbOnBlur={() => getPasswordMatchErrors()}
        cbOnEnter={handleResetClick}
        cbOnChange={handleConfirmPasswordChange}
      />
      <FooterContainer>
        <ChangePasswordButton
          cbClick={handleResetClick}
          className="ResetButton"
          buttonSize="large"
          buttonType="primaryGreen"
          ariaLabel={getIntlText(props.intl, 'RESET-PASSWORD-CHANGE-PASSWORD', 'Change Password')}
          isDisabled={inputsInvalid()}
          buttonLabel={getIntlText(props.intl, 'RESET-PASSWORD-CHANGE-PASSWORD', 'Change Password')}
        />
        <CancelButton
          cbClick={props.cbCancelClick}
          className="CancelButton"
          buttonSize="large"
          buttonType="secondary"
          ariaLabel={getIntlText(props.intl, 'RESET-PASSWORD-CANCEL', 'Cancel')}
          buttonLabel={getIntlText(props.intl, 'RESET-PASSWORD-CANCEL', 'Cancel')}
        />
      </FooterContainer>
    </ChangePasswordContainer>
  );
};

ChangePassword.propTypes = {
  cbResetClick: PropTypes.func,
  cbCancelClick: PropTypes.func,
  intl: PropTypes.object,
};

ChangePassword.defaultProps = {
  cbResetClick: () => { console.log("cbResetClick not defined"); },
  cbCancelClick: () => { console.log("cbCancelClick not defined"); }
};


export default injectIntl(ChangePassword);
